<template>
  <b-nav-item-dropdown right>
    <template #button-content>
      <div class="row align-middle">
        <div>
          <div class="text-right">
            <b-badge variant="warning" v-for="role in arrayRoles()" :key="role" class="mr-1">
              {{ $dict.getText($t('DIC.roles'), role) }}
            </b-badge>
          </div>
          <div class="text-right">
            {{$store.state.auth.userName}}
          </div>
        </div>
        <div class="align-middle mt-2 mx-2">
          <font-awesome-icon icon="user-circle" size="2x" fixed-width class=""/>
        </div>
      </div>
    </template>
    <b-dropdown-item @click="openModal"><font-awesome-icon :icon="$t('PAGES.Me.icon')" size="sm" fixed-width /> {{$t('PAGES.Me.title')}}</b-dropdown-item>
    <b-dropdown-divider />
    <b-dropdown-item @click="logoutUser()">
        <font-awesome-icon :icon="$t('PAGES.Logout.icon')" fixed-width /> {{$t('PAGES.Logout.title')}}
    </b-dropdown-item>
    <b-modal ref="input-modal" id="modal-1" size="xl" no-close-on-backdrop hide-footer>
      <template #modal-header>
        <PageTitle pageid="Me" />
      </template>
      <Me v-bind:userId="$store.state.auth.userId" @close="closeModel" />
    </b-modal>
  </b-nav-item-dropdown>
</template>

<script>
import PageTitle from '@/components/adminparts/PageTitle'
import Me from '@/components/Me'

export default {
  components: { PageTitle, Me },
  methods: {
    arrayRoles () {
      return this.$store.state.auth.roles.split(',')
    },
    logoutUser () {
      this.$swal({
        title: this.$t('PAGES.Logout.title'),
        text: this.$t('PAGES.Logout.swalConf'),
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: this.$t('BUTTON.logout'),
        cancelButtonText: this.$t('BUTTON.cancel'),
        reverseButtons: true
      })
        .then((result) => {
          if (result.isConfirmed) {
            // logout処理
            this.$store.dispatch('toast/showToast', {
              title: this.$t('PAGES.Logout.title'),
              message: this.$t('MESSAGE.logoutSuccess'),
              variant: 'success'
            })
            this.$store.commit('auth/destroy')
            localStorage.removeItem(this.$setting.SESSION_TOKEN_NAME)
            this.$router.push({name: 'Login'})
          } else {
            // キャンセル
          }
        })
    },
    openModal () {
      this.$refs['input-modal'].show()
    },
    closeModel (e) {
      this.$refs['input-modal'].hide()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/adminparts/UserMenu.vue